import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { articlePreviews, articleImages } from '@/mocks/articles';

export default function ArticlePreview() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -340 : 340,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
            <div>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
                Latest <span className="text-accent-600">Guides</span>
              </h2>
              <p className="text-sm text-foreground-500 mt-2">
                SEO-optimized buying tips &amp; seller reviews — {articlePreviews.length} articles
              </p>
            </div>
            <div className="flex items-center gap-3">
              <button
                onClick={() => scroll('left')}
                className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-500 hover:bg-foreground-50 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-s-line text-lg"></i>
              </button>
              <button
                onClick={() => scroll('right')}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-s-line text-lg"></i>
              </button>
            </div>
          </div>

          <div
            ref={scrollRef}
            className="flex gap-5 overflow-x-auto scrollbar-hide pb-4"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {articlePreviews.map((article) => (
              <Link
                key={article.slug}
                to={`/guide/${article.slug}`}
                className="flex-shrink-0 w-[300px] md:w-[330px] group cursor-pointer"
              >
                <div className="bg-background-100 rounded-2xl overflow-hidden transition-all duration-300 group-hover:-translate-y-1">
                  <div className="h-[200px] overflow-hidden">
                    <img
                      src={articleImages[article.imageSeq]}
                      alt={article.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                      <span>{article.date}</span>
                      <span>&middot;</span>
                      <span>{article.readTime}</span>
                    </div>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug line-clamp-2 mb-3 group-hover:text-primary-500 transition-colors">
                      {article.title}
                    </h3>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-foreground-500 line-clamp-1 flex-1 mr-3">
                        {article.excerpt.substring(0, 80)}...
                      </span>
                      <span className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 flex-shrink-0 group-hover:bg-primary-500 transition-colors">
                        <i className="ri-arrow-right-line text-sm"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}